namespace $.$$ {
	$mol_style_define( $shm_hitalama_quick2_reorder, {
		Panel: { position: 'relative' },
		Drag: { height: '2.5rem' },
	} )
}
